import WelcomeDashboard from "./welcome-dashboard";

const Dashboard = () => {
  return <WelcomeDashboard />;
};

export default Dashboard;
